import { Component, input } from '@angular/core';

@Component({
  selector: 'app-sidebar-section-title',
  template: `
    <li class="px-2.5 pt-4 pb-2">
      <span class="text-sm font-semibold text-gray-500 uppercase">
        {{ title() }}
      </span>
    </li>
  `,
  styles: [],
  standalone: false,
})
export class SidebarSectionTitleComponent {
  title = input.required<string>();
}
